import { ComputedRef } from 'vue'

import { ModelAnswerSourceCodeViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerSourceCodeViewModel'

export class ModelAnswerSourceCodePresenter {
  private viewModel: ModelAnswerSourceCodeViewModel

  constructor(viewModel: ModelAnswerSourceCodeViewModel) {
    this.viewModel = viewModel
  }

  get modelAnswerSourceCodeList(): ComputedRef<{ [judgeId: number]: string }> {
    return this.viewModel.modelAnswerSourceCodeList
  }

  get loading(): ComputedRef<boolean> {
    return this.viewModel.loading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  async fetchModelAnswerSourceCodeList(judgeId: number): Promise<void> {
    await this.viewModel.fetchModelAnswerSourceCodeList(judgeId)
  }
}
